import React from "react";
import { useStyles } from "./styles";

export const StatisticWidgetSource = ({ children, ...props }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const classes = useStyles(props);

  return (
    <div className={classes.source} ref={ref}>
      {children}
    </div>
  );
};
StatisticWidgetSource.muiName = "StatisticWidgetSource";
StatisticWidgetSource.displayName = "StatisticWidgetSource";

export default StatisticWidgetSource;
